import { Restaurant, Schedule, ArrowUpward, ArrowDownward } from '@mui/icons-material'
import {
  Box,
  CardHeader,
  FormControl,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography,
} from '@mui/material'

import React from 'react'
import { useTranslation } from 'react-i18next'

export type MenuSortOption =
  'itemType' | 'mostOrdered' | 'highestRated' | 'newest' | 'priceLowToHigh' | 'priceHighToLow'

const SORT_OPTIONS: Array<{
  value: MenuSortOption
  icon: React.ComponentType<{ fontSize?: 'small' }>
}> = [
  { value: 'itemType', icon: Restaurant },
  //   TODO - add these when data is available for use
  //   { value: 'mostOrdered', icon: Whatshot },
  //   { value: 'highestRated', icon: StarBorder },
  { value: 'newest', icon: Schedule },
  { value: 'priceLowToHigh', icon: ArrowUpward },
  { value: 'priceHighToLow', icon: ArrowDownward },
]

type Props = {
  itemCount: number
  sortOption: MenuSortOption
  onChangeSortOption: (sortOption: MenuSortOption) => void
}

const MenuSort: React.FC<Props> = ({ itemCount, sortOption, onChangeSortOption }) => {
  const { t } = useTranslation()

  const handleChange = (event: SelectChangeEvent) => {
    onChangeSortOption(event.target.value as MenuSortOption)
  }

  return (
    <Box>
      <CardHeader
        title={t('cc:showingItems', { count: itemCount })}
        slotProps={{ title: { variant: 'h6', color: 'text.secondary', fontWeight: 400 } }}
        sx={{
          padding: '8px 0',
          alignItems: 'center',
          '& .MuiCardHeader-action': { alignSelf: 'center', margin: 0 },
        }}
        action={
          <FormControl size="small" sx={{ minWidth: 230 }}>
            <Select
              value={sortOption}
              onChange={handleChange}
              sx={{ backgroundColor: '#F4F4F4' }}
              renderValue={(selected) => (
                <Typography component="span" variant="body2" fontWeight={400}>
                  {t('cc:sortBy')}{' '}
                  <Typography component="span" variant="body2" fontWeight={600}>
                    {t(`cc:sortOptions.${selected}`)}
                  </Typography>
                </Typography>
              )}>
              {SORT_OPTIONS.map((option) => {
                const Icon = option.icon
                return (
                  <MenuItem key={option.value} value={option.value}>
                    <ListItemIcon sx={{ minWidth: 32 }}>
                      <Icon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText
                      primary={t(`cc:sortOptions.${option.value}`)}
                      secondary={t(`cc:sortOptionDescriptions.${option.value}`)}
                      slotProps={{
                        primary: { variant: 'body2', fontWeight: 600 },
                        secondary: { variant: 'caption', color: 'text.secondary' },
                      }}
                    />
                  </MenuItem>
                )
              })}
            </Select>
          </FormControl>
        }
      />
    </Box>
  )
}

export default MenuSort
